import Konva from 'konva'
import _ from 'lodash'
import 'gifler'

export default {
  data: () => ({
    konva: {
      stage: {
        width: 320,
        height: 180,
      },
      img: {
        name: 'konvaImage',
        image: new Image(),
        draggable: true,
        rotation: 0,
        scaleX: 0.5,
        scaleY: 0.5,
        x: 0,
        y: 0,
      },
      file: null,
      percent: 0.5,
      anima: null,
      id: null,
      lib: [],
      oldMutedValue: null,
      gif: null,
      animator: null,
      clickOutside: false,
    },
    isBrowserBrave: false,
    // eslint-disable-next-line no-undef
    gifler,
  }),
  provide() {
    return {
      konva: this.konva,
    }
  },
  watch: {
    'konva.file': {
      handler(file) {
        const vm = this
        let image = null
        let gif = null
        let animator = null

        if (file) {
          image = new window.Image()
          image.src = this.fileData.url
        }

        if (!image) return

        image.onload = ({ srcElement }) => {
          vm.setKonvaStageSize()

          const { width: stageWidth, height: stageHeight } = vm.konva.stage
          let { naturalWidth: imageWidth, naturalHeight: imageHeight } =
            srcElement

          const imageRatio = imageHeight / imageWidth

          if (imageWidth >= stageWidth) {
            imageWidth = stageWidth * vm.konva.percent
            imageHeight = imageWidth * imageRatio
          }

          vm.$set(vm.konva.img, 'width', imageWidth)
          vm.$set(vm.konva.img, 'height', imageHeight)

          if (!vm.fileData.isString) {
            vm.konva.img.x = Math.abs(stageWidth / 2 - imageWidth / 4)
            vm.konva.img.y = Math.abs(stageHeight / 2 - imageHeight / 4)
          }

          if (vm.fileData.isGIF) {
            image = document.createElement('canvas')
            gif = this.gifData
          }

          vm.$set(vm.konva.img, 'image', image)
          vm.$set(vm.konva, 'gif', gif)
          vm.$set(vm.konva, 'animator', animator)
          vm.updateTransformer()
        }
      },
      deep: true,
    },
  },
  computed: {
    fileData() {
      const { file } = this.konva

      if (file === null) return {}

      const isString = _.isString(file)

      const name = isString ? file : file.name
      const extension = name.split('.').pop().toLowerCase()
      const url = isString ? file : URL.createObjectURL(file)
      const isGIF = extension === 'gif'

      return {
        isString,
        isGIF,
        name,
        extension,
        url,
      }
    },
    gifData() {
      const vm = this
      const layer = this.$refs?.layer?.getNode() ?? null

      if (this.konva.file === null) return {}

      return this.gifler(this.fileData.url).get(function (animator) {
        animator.animateInCanvas(vm.konva.img.image)

        if (!layer) return

        if (!vm.konva.anima) {
          vm.konva.anima = new Konva.Animation(() => {}, layer)
        }
        vm.konva.anima.start()

        vm.$set(vm.konva, 'animator', animator)
      })
    },
  },
  methods: {
    toggleListenerClickOutside(state) {
      if (state) {
        if (this.konva.clickOutside) return
        this.konva.clickOutside = true
        window.addEventListener('click', this.handleClickOutside)
      } else {
        this.konva.clickOutside = false
        window.removeEventListener('click', this.handleClickOutside)
      }
    },
    handleClickOutside({ target }) {
      const closest = target.closest('.konva__stage')

      if (closest) return

      this.updateTransformer(false)
    },
    setKonvaImageSize({ width, height }) {
      this.konva.img.x = width * 0.5
      this.konva.img.y = height * 0.5
      this.konva.img.rotation = 0
      this.konva.img.scaleX = 0.5
      this.konva.img.scaleY = 0.5
    },
    setKonvaStageSize() {
      const { player } = this.$refs
      const vm = this

      let width = 320
      let height = 180

      if (player) {
        const span = player.querySelector('.konva__player')

        if (!span)
          return setTimeout(() => {
            vm.setKonvaStageSize()
          }, 1500)

        const { offsetWidth, offsetHeight } = span

        width = offsetWidth
        height = offsetHeight
      } else
        return setTimeout(() => {
          vm.setKonvaStageSize()
        }, 1500)

      // set stage
      this.konva.stage.width = width
      this.konva.stage.height = height

      if (this.konva.file && !_.isString(this.konva.file))
        this.setKonvaImageSize({ width, height })
    },
    handleTransformEnd({ target }) {
      const item = this.konva.img

      item.x = target.x()
      item.y = target.y()
      item.rotation = target.rotation()
      item.scaleX = target.scaleX()
      item.scaleY = target.scaleY()
    },
    updateTransformer(toSelect = true) {
      if (!this.$refs?.transformer || !this.$refs?.transformer?.getNode) return

      const transformerNode = this.$refs.transformer.getNode()
      const stage = transformerNode.getStage()
      const selectedNode = stage.findOne('.konvaImage')

      if (toSelect) {
        if (selectedNode === transformerNode.node()) return
        else transformerNode.nodes([selectedNode])
      } else {
        transformerNode.nodes([])
      }

      this.toggleListenerClickOutside(toSelect)
    },
  },
  // ...
}
